import type { NextApiRequest, NextApiResponse } from 'next'
import type { Language, StorefrontDiscountCodeResponse } from 'ecosystem'
import storefrontApi from 'api/storefront-api'
import { useLocaleCredentials as setLocaleCredentials } from 'api'
import { handlerWithLogging } from '../../logging'

export const getDiscountCodeHandler = handlerWithLogging(
  async (
    req: NextApiRequest,
    res: NextApiResponse<StorefrontDiscountCodeResponse | { error: string }>
  ) => {
    const locale = (req.cookies.NEXT_LOCALE as Language) || 'sv'
    setLocaleCredentials(locale)
    if (req.method !== 'POST') {
      res.status(405).json({ error: 'Method not supported.' })
      return
    }

    const { code }: { code: string } = req.body

    if (!code) {
      res.status(400).json({ error: 'Incorrect code.' })
      return
    }

    const { error, data } = await storefrontApi.store.getDiscountCode({ code })
    if (error || !data) {
      res
        .status(400)
        .json({ error: typeof error === 'string' ? error : error?.error || 'Unknown error' })
      return
    }

    res.status(200).json({ data })
  }
)
